export default "__VITE_ASSET__DWjhggvm__"